const REPORTED = new WeakSet<Error>();
const NORMALIZED = new WeakSet<Error>();

// Marks an Error as already sent to Sentry via our reporting pipeline (dedup for top-level capture)
export function markReported(err: Error): void {
  try {
    REPORTED.add(err);
  } catch {}
}

// True if the Error was already reported via our pipeline
export function isReported(x: unknown): boolean {
  return x instanceof Error && REPORTED.has(x);
}

// Marks an Error as already normalized/enriched by our pipeline (skip beforeSend enrichment)
export function markNormalized(err: Error): void {
  try {
    NORMALIZED.add(err);
  } catch {}
}

// True if the Error was already normalized by our pipeline
export function isNormalized(x: unknown): boolean {
  return x instanceof Error && NORMALIZED.has(x);
}
